import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, lastValueFrom, takeUntil, timeout } from 'rxjs';

export interface HttpRequestOptions {
  headers: HttpHeaders;
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class HttpService {

  timeout: number = 40000;
  constructor(private http: HttpClient) { }

  options(): HttpRequestOptions {
    return {
      headers: new HttpHeaders({
      }),
      withCredentials: true
    };
  }

  async post<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.postObservable(url, arg, destroy$, options));
  }

  postObservable<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Observable<T> {
    if (destroy$) {
      return this.http.post<T>(`${url}`, arg, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.post<T>(`${url}`, arg, options).pipe(timeout(this.timeout));
    }
  }

  async get<T>(url: string, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.getObservable(url, destroy$, options));
  }

  async getWithParams<T>(url: string, params: HttpParams, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.getObservable(url, destroy$, options, params));
  }

  getObservable<T>(url: string, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options(), params: HttpParams = new HttpParams): Observable<T> {
    if (destroy$) {
      return this.http.get<T>(url, { headers: options.headers, params: params }).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.get<T>(url, { headers: options.headers, params: params }).pipe(timeout(this.timeout));
    }
  }

  async put<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.putObservable(url, arg, destroy$, options));
  }

  putObservable<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Observable<T> {
    if (destroy$) {
      return this.http.put<T>(`${url}`, arg, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.put<T>(`${url}`, arg, options).pipe(timeout(this.timeout));
    }
  }

  async delete<T>(url: string, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.deleteObservable(url, destroy$, options));
  }

  deleteObservable<T>(url: string, destroy$: Subject<void> | null = null, options: HttpRequestOptions = this.options()): Observable<T> {
    if (destroy$) {
      return this.http.delete<T>(url, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.delete<T>(url, options).pipe(timeout(this.timeout));
    }
  }

  queryGenerator(params: any) : string {
    if(!params) {
      return '';
    }

    return Object.keys(params)
    .filter(key => params[key] !== null)
    .filter(key => params[key] !== undefined)
      .filter(key => params[key] !== '')
    .map(key => `${key}=${params[key]}`)
    .join('&');
  }
}
